import { Label } from '@core/models/labels.model';
import { Tag } from '@core/models/tags.model';

export interface TagsLabelsState {
  tags: Tag[];
  tagsLoading: boolean;
  tagsError: string | null;

  labels: Label[];
  labelsLoading: boolean;
  labelsError: string | null;

  formSaving: boolean;
  formError: string | null;
  formSuccess: boolean;
}

export const initialTagsLabelsState: TagsLabelsState = {
  tags: [],
  tagsLoading: false,
  tagsError: null,

  labels: [],
  labelsLoading: false,
  labelsError: null,

  formSaving: false,
  formError: null,
  formSuccess: false
};
